import { useMemo, useState } from "react";
import { useToast } from "../../../Hooks/UseToast";
import Navbar from "../../Navbar";
import SemaforoTable from "../components/table/SemaforoTable";
import { useSemaforo } from "../hooks/useSemaforo";
import { DEFAULT_FILTERS_SEMAFOROS } from "../config/DEFAULT_FILTERS_SEMAFOROS";
import { MODAL_TYPES_SEMAFORO } from "../config/MODAL_TYPES";
import { useSemaforoCatalogo } from "../hooks/useSemaforoCatalogo";
import { useSemaforoExcel } from "../hooks/useDownloadExcel";
import ModalManagerSemaforo from "../modals/ModalManager";

const SemaforoPage = () => {
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  const [filtros, setFiltros] = useState(DEFAULT_FILTERS_SEMAFOROS);
  const [modal, setModal] = useState(null);

  const { data, loading, error, refresh } = useSemaforo(filtros);
  const catalogo = useSemaforoCatalogo();
  // console.log("Catalogo: ", catalogo);

  const { Toast, showToast } = useToast();

  // console.log("Data: ", data);

  const totales = useMemo(() => {
    return data.reduce(
      (acc, cliente) => {
        acc.vencidos += Number(cliente.vencidos || 0);
        acc.noVencidos += Number(cliente.no_vencidos || 0);
        acc.totalCtaCte += Number(cliente.total_cta_cte || 0);
        acc.totalCheques += Number(cliente.total_cheques || 0);
        acc.total += Number(cliente.total || 0);

        return acc;
      },
      {
        vencidos: 0,
        noVencidos: 0,
        totalCtaCte: 0,
        totalCheques: 0,
        total: 0,
      },
    );
  }, [data]);

  const { downloadExcel, loading: loadingExcel } = useSemaforoExcel();

  const handleDownloadExcel = () => {
    downloadExcel(filtros);
  };

  const kpis = useMemo(() => {
    if (!data || data.length === 0) {
      return { rojo: 0, amarillo: 0, blanco: 0, total: 0 };
    }
    return data.reduce(
      (acc, cliente) => {
        acc[cliente.semaforo?.toLowerCase() || "blanco"] += 1;
        acc.total += 1;
        return acc;
      },
      { rojo: 0, amarillo: 0, blanco: 0, total: data.length },
    );
  }, [data]);

  const handleRowClick = (cliente) => {
    setClienteSeleccionado(cliente);

    openModal(MODAL_TYPES_SEMAFORO.ABRIR_CUENTACORRIENTE, {
      cliente,
    });
  };

  const openModal = (type, props = {}) => {
    setModal({ type, ...props });
  };

  const handleToolbarAction = ({ type }) => {
    switch (type) {
      case MODAL_TYPES_SEMAFORO.ABRIR_FILTROS:
        openModal(MODAL_TYPES_SEMAFORO.ABRIR_FILTROS, {
          filtros,
          setFiltros,
          clientes: catalogo.clientes,
          categorias: catalogo.categorias,
          sucursales: catalogo.sucursales,
          clientesEnvasado: catalogo.clientesEnvasado,
        });
        break;

      case MODAL_TYPES_SEMAFORO.EXPORTAR_EXCEL:
        handleDownloadExcel();
        break;

      default:
        break;
    }
  };

  return (
    <>
      <Navbar />
      <SemaforoTable
        data={data}
        loading={loading}
        showToast={showToast}
        refresh={refresh}
        onToolbarAction={handleToolbarAction}
        onRowClick={handleRowClick}
        envasado={filtros.envasado}
        kpis={kpis}
        totales={totales}
      />
      <ModalManagerSemaforo
        modal={modal}
        onClose={() => setModal(null)}
        refresh={refresh}
        showToast={showToast}
      />
      {Toast}
    </>
  );
};

export default SemaforoPage;
